const MONTH_MAP = {
  Jan: 1, January: 1,
  Feb: 2, February: 2,
  Mar: 3, March: 3,
  Apr: 4, April: 4,
  May: 5,
  Jun: 6, June: 6,
  Jul: 7, July: 7,
  Aug: 8, August: 8,
  Sep: 9, Sept: 9, September: 9,
  Oct: 10, October: 10,
  Nov: 11, November: 11,
  Dec: 12, December: 12
};

export const parseGuideDate = (dateStr) => {
  if (!dateStr) return 0;
  const parts = dateStr.trim().split(' ');
  if (parts.length < 2) return 0;
  const month = MONTH_MAP[parts[0]] || 0;
  const year = parseInt(parts[1], 10) || 0;
  return year * 100 + month;
};

const RAW_GUIDES_DATA = [
  {
    id: "g7",
    slug: "home-buying-feng-shui-practical-guide-cn",
    title: "买房风水入门指南：实地看房必看的5大格局与避煞技巧",
    category: "Buying Guide",
    date: "June 2026",
    readTime: "8 分钟阅读",
    author: "妮可地产经纪 (Nicole Pua)",
    coverImage: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80",
    summary: "挑选心仪房产不仅看地段与价格，住宅的外部气场、室内通风采光及空间格局也至关重要。本文为您整理实地看房时需留意的 5 大实用风水避坑指南，助您买到居住舒适、藏风聚气的好房子。",
    highlights: [
      "外部环境避煞：避开路冲 (T-Junction)、反弓煞、天斩煞、高压电塔及医院庙宇周边",
      "大门关口：三大进门忌讳——开门不见灶（厨房）、不见厕（卫生间）、不见镜",
      "气流与采光：遵循“明厅暗室”原则，气流宜柔和对流，避免风速过强的“穿堂煞”",
      "厨房与卧室：灶台水槽避开“水火直冲”，主卧床头宜靠实墙避免“横梁压顶”",
      "第一直觉体验：重视首次走进房屋的直观体感（空气、光线、压迫感与整体磁场）"
    ],
    sections: [
      {
        heading: "一、外部环境观察：避开常见外部煞气",
        image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "现场看房时，除了看室内装修，首先要站在阳台或大门处观察周边的外部环境：",
          "1. 避开路冲煞与反弓煞：路冲指房屋正对直冲而来的马路；反弓煞指道路或河流像弯弓一样背对房屋弯曲。直冲的车流与强风容易造成心理压迫感与噪音干扰。",
          "2. 避开天斩煞：指房屋正对前方两座紧挨的高楼之间的狭窄缝隙，缝隙风口产生的“强气流”风速极大，影响居室安宁。",
          "3. 避开强磁场与特殊场所：高压电塔、加油站、医院、墓地或大型庙宇附近。高压电塔磁场较强，加油站挥发物多，医院庙宇人流杂乱，长期居住可能影响睡眠与心情。",
          "4. 观察栋距与采光：注意相邻楼栋的间距，避免前方高楼完全遮挡阳光导致室内终年阴暗潮湿。充足的自然采光是优良风水的基础。"
        ]
      },
      {
        heading: "二、大门与进门玄关：藏风聚气的首要关口",
        image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "住宅大门是房屋出入纳气的关口。看房时重点留意以下“三大进门忌讳”：",
          "• 避免穿堂煞：大门打开直对后门或阳台落地窗，气流从大门直穿而出无法在室内留存。若遇到此类户型，可通过设计玄关屏风、鞋柜或加装窗帘进行视觉与气流阻隔化解。",
          "• 避免开门见灶：入户一眼看到厨房炉灶，油烟易外溢，传统习惯认为厨房代表家财，公开外露不利于财气聚集。",
          "• 避免开门见厕与见镜：大门直对卫生间门影响卫生与观瞻；大门直对大镜子容易在夜间反射光线，给人带来惊吓感。"
        ]
      },
      {
        heading: "三、采光通风与室内动线：遵循“明厅暗室”",
        paragraphs: [
          "理想的室内空间设计与风水理念高度吻合，核心在于居住的舒适度：",
          "1. 明厅暗室原则：客厅（明厅）宜宽敞明亮、视野开阔，充足的阳光能调和气场，让家人心情愉悦；卧室（暗室）宜温馨沉稳、光线柔和，利于放松与睡眠。",
          "2. 藏风聚气：房屋通风要好，但气流宜柔和缓慢地循环对流。避免室内出现穿堂强风直吹，导致保温与舒适度下降。",
          "3. 户型方正：选择格局方正、无严重畸形缺角的户型，不仅空间利用率高，动线规划也更加流畅方便。"
        ]
      },
      {
        heading: "四、厨房与卧室实操：避免水火相克与横梁压顶",
        paragraphs: [
          "进到室内细节观察时，需重点检验两个核心生活区域：",
          "• 厨房水火不冲：水槽（水）与炉灶（火）不宜正对摆放或紧挨着（如距离小于 60 公分），最好呈 L 型摆放或保持合理操作距离，避免水油飞溅发生危险。",
          "• 卧室床头靠山：主卧床头应靠实墙摆放（避免床头贴窗悬空）；床的正上方应避免大型粗大的横梁直接压过（横梁压顶易在心理上造成沉重压迫感）。"
        ]
      },
      {
        heading: "五、看房时的直觉体感：重视您的第一印象",
        paragraphs: [
          "看房时除了对照风水要点，买家自身的“第一直觉体感”同样非常直观：",
          "当您第一次步入房屋时，感受空气是否清新通透、室内采光是否让人神清气爽、空间是否有压抑晦暗的沉闷感。",
          "一栋适合您的优质住宅，往往能在您踏入的第一瞬间带来温馨、明亮、安心的舒适感受。"
        ],
        callout: "买房建议：“风水的科学本质是现代建筑学中的采光、通气对流、空间动线与环境心理学。”选房时只要地段便利、格局方正、采光通透、居住舒心，便是真正属于您的理想好房。"
      }
    ]
  },
  {
    id: "g3",
    slug: "top-townships-iskandar-puteri-comparison",
    title: "Top Townships in Iskandar Puteri: Comparing Bukit Indah, Horizon Hills & Eco Botanic",
    category: "Township Insights",
    date: "June 2026",
    readTime: "8 min read",
    author: "Nicole Pua",
    coverImage: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
    summary: "An in-depth lifestyle and investment comparison of Iskandar Puteri's three premier townships. Discover security features, school proximity, accessibility, and price appreciation.",
    highlights: [
      "Bukit Indah: The mature heart of Iskandar Puteri with unmatched commercial convenience.",
      "Horizon Hills: Premium resort living with an 18-hole international golf course & high security.",
      "Eco Botanic: High-end lifestyle hub inspired by English architecture & near EduCity.",
      "Price per sqft trends and rental demand analysis for home buyers & investors."
    ],
    sections: [
      {
        heading: "1. Bukit Indah: Unbeatable Convenience & Accessibility",
        paragraphs: [
          "Bukit Indah remains one of Johor Bahru's most sought-after residential areas. Built around a 20-acre town park, it houses AEON Mall Bukit Indah, Lotus's, TF Value-Mart, major bank branches, and over 200 F&B eateries.",
          "Accessibility: Situated right on the Coastal Highway and Tuas 2nd Link expressway, commuting to Singapore or JB City Centre takes under 15-20 minutes."
        ]
      },
      {
        heading: "2. Horizon Hills: Eco-Resort Living & Golf Community",
        paragraphs: [
          "Spanning over 1,200 acres, Horizon Hills is a low-density joint development by Gamuda Land & UEM Sunrise. Features double-tiered security guardhouses, lush parks, and an exclusive private clubhouse.",
          "Property Types: Double-storey terrace, cluster houses, semi-detached, and luxury golf-facing bungalows."
        ]
      },
      {
        heading: "3. Eco Botanic: Premium Architecture & EduCity Hub",
        paragraphs: [
          "Developed by Eco World, Eco Botanic stands out with its grand entrance boulevard, English colonial architecture, and Eco Galleria commercial boulevard.",
          "Proximity to Schools: Located right next to EduCity (Newcastle University, University of Reading, Marlborough College, and Raffles American School)."
        ]
      }
    ]
  },
  {
    id: "g1",
    slug: "buying-jb-property-singaporeans-guide",
    title: "Complete Guide to Buying Property in Johor Bahru for Singaporeans (2026 Edition)",
    category: "Foreign Buyers",
    date: "May 2026",
    readTime: "7 min read",
    author: "Nicole Pua",
    coverImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80",
    summary: "Everything Singaporean buyers & investors need to know about purchasing JB real estate: foreign ownership thresholds, RTS Link impact, state consent fees, and financing options.",
    highlights: [
      "Minimum RM 1,000,000 threshold for foreign property buyers in Johor.",
      "RTS Link travel time reduced to 5-10 minutes between JB Sentral & Woodlands North.",
      "Key breakdown of legal fees, state consent tax (2%), and stamp duty costs.",
      "How to obtain up to 70-80% bank financing from Malaysian & Singaporean banks."
    ],
    sections: [
      {
        heading: "1. Why Johor Bahru is a Top Choice for Singapore Buyers",
        paragraphs: [
          "With the upcoming completion of the Johor Bahru–Singapore Rapid Transit System (RTS Link), cross-border commuting between Woodlands North and Bukit Chagar JB Sentral is easier than ever. Combined with favorable exchange rates, lower living costs, and spacious landed living, JB properties present an attractive option for both own-stay and long-term rental yields.",
          "As an ex-Finance Specialist in SG now serving as a registered property negotiator in JB, I frequently advise Singaporean clients looking for holiday homes, retirement living, or high-yield investment properties."
        ]
      },
      {
        heading: "2. Foreign Ownership Minimum Purchase Threshold",
        paragraphs: [
          "Under Johor State Land Rules, foreign citizens and foreign companies can purchase residential properties subject to specific minimum price thresholds:",
          "• Direct Developer Purchases (Primary Market): Minimum threshold is RM 1,000,000 for most international zone residential units.",
          "• Subsale Market (Secondary Market): Minimum threshold is generally RM 1,000,000 for strata and landed homes in designated international zones (e.g., Bukit Indah, Horizon Hills, Eco Botanic, Medini).",
          "Note: Medini Iskandar enjoys special economic zone status where foreign purchase threshold restrictions and state consent fees are exempted for selected developments."
        ],
        callout: "Important: Always verify whether a property carries an International Lot title or Bumi Lot status before placing a booking deposit."
      },
      {
        heading: "3. Breakdown of Fees & Transaction Costs",
        paragraphs: [
          "When planning your budget for buying a JB property, account for the following upfront transaction expenses:",
          "1. Foreign State Consent Fee: 2% of the purchase price (or minimum RM 20,000) payable to the Johor State Authority.",
          "2. Buyer's Stamp Duty (MOT): Scaled rate from 1% for first RM 100k up to 4% for amounts above RM 1,000,000.",
          "3. Legal Fees for Sales & Purchase Agreement (SPA): Regulated scale fees ranging from 0.5% to 1% of property value.",
          "4. Loan Agreement Legal Fees & Stamp Duty: 0.5% stamp duty on total loan facility plus lawyer preparation fees."
        ]
      },
      {
        heading: "4. Step-by-Step Purchasing Process",
        paragraphs: [
          "Step 1: Selection & Booking - Secure the property with a 2% to 3% earnest deposit and sign the Option to Purchase (OTP) or Offer Letter.",
          "Step 2: Mortgage Application - Apply for home loans with Malaysian banks (Maybank, CIMB, RHB, UOB) or offshore SG banks.",
          "Step 3: SPA Signing - Sign the Sales & Purchase Agreement within 14 to 21 working days and pay the balance 10% down payment.",
          "Step 4: State Consent Submission - Lawyer submits foreign consent application to Johor Land Office (takes ~2 to 3 months).",
          "Step 5: Completion & Key Handover - Upon state consent approval and final loan disbursement, vacant possession is delivered!"
        ]
      }
    ]
  },
  {
    id: "g2",
    slug: "first-time-homebuyer-guide-johor-bahru",
    title: "First-Time Homebuyer Guide in Johor Bahru: Step-by-Step & Cost Breakdown",
    category: "Buying Guide",
    date: "May 2026",
    readTime: "6 min read",
    author: "Nicole Pua",
    coverImage: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1200&q=80",
    summary: "Navigating your very first home purchase in JB? Discover essential tips on credit eligibility, choosing between new launch vs subsale, and avoiding common legal traps.",
    highlights: [
      "Comparing New Launch vs. Subsale (Secondary) Property advantages.",
      "How to evaluate DSR (Debt Service Ratio) to ensure 90% loan approval.",
      "Stamp duty exemptions available for eligible first-time Malaysian buyers.",
      "Key checklist during key handover & defect inspection."
    ],
    sections: [
      {
        heading: "1. New Launch vs. Subsale Property: Which Suits You Best?",
        paragraphs: [
          "First-time buyers in JB often debate between buying brand-new developer units or established subsale homes:",
          "• New Launch Advantages: Lower upfront cash requirement (many developers offer zero downpayment packages, free legal fees, and absorption of MOT), brand new fixtures, and warranty defect period (24 months).",
          "• Subsale Advantages: Ready to move in immediately, established mature township amenities (e.g. Bukit Indah, Taman Gaya), clear existing neighborhood condition, and immediate rental income potential."
        ]
      },
      {
        heading: "2. Calculating Your Financial Eligibility (DSR)",
        paragraphs: [
          "Malaysian banks calculate your maximum loan capacity using Debt Service Ratio (DSR):",
          "DSR Formula = (Total Monthly Commitment + New Housing Loan) / Net Monthly Income",
          "Most commercial banks cap healthy DSR at 65% to 70%. Ensure your credit score (CCRIS / CTOS) is clean without late payment records over the past 12 months."
        ]
      },
      {
        heading: "3. First-Time Buyer Stamp Duty Remission",
        paragraphs: [
          "Malaysian first-time home buyers purchasing residential properties priced below RM 500,000 qualify for 100% stamp duty exemption on both the Memorandum of Transfer (MOT) and loan agreement under ongoing government housing incentives."
        ]
      }
    ]
  },
  {
    id: "g5",
    slug: "mrta-vs-mlta-mortgage-insurance-guide-cn",
    title: "MRTA 与 MLTA 房贷保险终极对比：买房保单怎么选才不踩坑？",
    category: "Buying Guide",
    date: "Apr 2026",
    readTime: "6 分钟阅读",
    author: "妮可地产经纪 (Nicole Pua)",
    coverImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80",
    summary: "买房申请房屋贷款时，MRTA 与 MLTA 该如何选择？本文为您清晰拆解两种房贷保险的定义、保费支付方式、受益人归属及转让灵活性，助您选出最符合个人财务规划的保障方案。",
    highlights: [
      "MRTA (递减式)：保额随房贷本金同步递减，保费一次性结清且可纳入房贷额度",
      "MLTA (恒定式)：保额全程恒定不变，理赔金直接发放给指定家属受益人",
      "受益人区别：MRTA 理赔金优先支付银行还清房贷；MLTA 余款与保障留给家人",
      "保单转移：MRTA 与特定房屋挂钩；MLTA 随个人走，换房可直接转让给新房",
      "选择建议：短期投资客与家庭支柱选 MLTA；预算有限与自住客选 MRTA"
    ],
    sections: [
      {
        heading: "一、什么是 MRTA 与 MLTA？核心定义拆解",
        image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "在马来西亚申请房屋贷款时，银行通常会建议或要求借款人购买房贷保险，以防止借款人发生意外（不幸身故或永久残疾）时房屋遭到破产清算。",
          "• MRTA (Mortgage Reducing Term Assurance 递减式房贷保险)：保障额度随着您每年偿还房贷本金而同步递减。它的核心保障对象是“放贷银行”，一旦发生意外，保险公司直接将理赔金拨给银行还清剩余房贷。",
          "• MLTA (Mortgage Level Term Assurance 恒定式房贷保险)：保障额度在整个贷款期内维持不变。它的核心保障对象是“借款人与家人”，意外发生时，保险公司先帮你清还银行剩余房贷，剩余的保额现金将全部发放给您指定的受益家属。"
        ]
      },
      {
        heading: "二、MRTA vs MLTA 核心差异对比表格分析",
        image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "为了方便首购族快速厘清，以下为两大房贷保险的关键对比要点：",
          "1. 保费支付方式：MRTA 通常为一次性保费（保费可直接加进房贷总额中一起分期供）；MLTA 则是按月、按季或按年定期缴付保费。",
          "2. 受益人归属：MRTA 的第一受益人必定是放贷银行；MLTA 的受益人由借款人自由指定（如配偶或子女）。",
          "3. 保单转移灵活性：MRTA 与特定房产强绑定，若几年后卖房或 refinance 转贷，保单无法直接套用给新房；MLTA 属于随人走的保单，卖房后可直接转移覆盖新购房产。",
          "4. 储蓄与现金价值：MRTA 没有储蓄红利或现金价值；大部分 MLTA 保单带有储蓄分红成分，保单到期后可领回部分现金价值。"
        ]
      },
      {
        heading: "三、买家该怎么选？实战决策指南",
        paragraphs: [
          "根据不同买家的财务状况与购房目的，建议如下：",
          "• 适合选择 MRTA 的人群：首购现金流紧绷者（可将保费加入房贷分期供）、打算长期自住不轻易搬迁者、以及个人已经拥有充沛人寿与重疾保险保障者。",
          "• 适合选择 MLTA 的人群：家庭唯一的经济支柱（需确保发生意外时家人能拿到额外现金保障）、打算在 3 至 5 年内卖房换房的投资客、以及希望兼具房贷保障与储蓄理财功能的买家。"
        ],
        callout: "建议：买房前不必被银行强行推销绑架，可根据自身的保单缺口与现金流状况，向专业地产经纪或独立保险理财师咨询后择优配置。"
      }
    ]
  },
  {
    id: "g6",
    slug: "foreign-buyer-mm2h-pr-malaysia-property-guide-cn",
    title: "外国人与MM2H在马来西亚买房全攻略：门槛、准证与身份权益对比",
    category: "Foreign Buyers",
    date: "Apr 2026",
    readTime: "7 分钟阅读",
    author: "妮可地产经纪 (Nicole Pua)",
    coverImage: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
    summary: "详细解析外籍人士、MM2H第二家园持有人及PR永久居民在马来西亚购房的政策规定、各州最低购房价格门槛、州政府同意书(State Consent)以及房贷成数权益对比。",
    highlights: [
      "外籍买家三大购房禁区：低成本房屋、土著保留地 (Bumi Lot) 及大部分农业地",
      "各州最低价格门槛：柔佛与吉隆坡大多为 RM 1,000,000；Medini 特区享特别豁免",
      "身份权益对比：普通外籍身份 vs MM2H 第二家园 vs PR 永久居民购房政策与贷款成数",
      "州政府同意书 (State Consent Fee)：2% 关税算式、审核时间与必备退款保障条款"
    ],
    sections: [
      {
        heading: "一、外国人可以在马来西亚买房吗？核心限制与门槛",
        image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "马来西亚是东南亚少数允许外国公民直接以个人名义购买并持有永久产权 (Freehold) 或 99 年租赁产权 (Leasehold) 房产的国家之一。",
          "但是，为了保护本地中低收入群体的购房权益，马来西亚政府对外籍买家设定了三大核心限制：",
          "1. 禁购房屋类型：不得购买政府划定的低成本房屋 (Low-cost housing)、土著保留配额房产 (Bumi Lot / Malay Reserve) 以及未经批准的农业土地。",
          "2. 各州最低价格门槛：外籍买家购房必须符合各州政府规定的最低价格要求。例如在柔佛州 (Johor) 及吉隆坡 (Kuala Lumpur)，外籍买家购房的最低门槛普遍为 RM 1,000,000（某些特定州属或特殊经济区有所不同）。",
          "3. 经济特区豁免：如位于依斯干达特区核心的美迪尼 (Medini Iskandar)，部分特定开发项目享有豁免外国买家最低门槛及免征州政府同意书费用的特殊优惠。"
        ]
      },
      {
        heading: "二、普通外籍身份 vs MM2H (第二家园) vs PR (永久居民) 购房权益对比",
        image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "不同身份身份的外籍买家在买房限制与银行贷款权益上存在明显区别：",
          "• 普通外籍买家 (Standard Foreign Buyer)：严格受最低 RM 1,000,000 价格门槛限制；必须申请并缴纳 2% 州政府同意书关税 (State Consent Fee)；银行房贷成数通常在 50% 至 70% 之间。",
          "• MM2H (第二家园持有人)：享有长期居住签证优势，在某些特定州属购房可享有较低的价格门槛优惠（视最新第二家园政策阶梯而定）；银行审批房贷时认可度更高，贷款成数可达 70% 至 80%。",
          "• PR (永久居民)：买房政策与限制基本与马来西亚本地公民一致，不受外籍最低门槛限制，无需缴纳 2% 州政府同意书费，银行最高可发放高达 85% 至 90% 的房贷。"
        ]
      },
      {
        heading: "三、州政府同意书 (State Consent) 申请与流程要点",
        paragraphs: [
          "所有普通外籍买家在签署买卖合同 (SPA) 后，代理律师必须向当地州政府土地局 (Land Office) 代为提交外籍购房准证申请 (State Consent Application)。",
          "在柔佛州，申请 State Consent 需向州政府缴纳相当于房屋成交价 2%（或最低 20,000 令吉）的同意书征费，审批时间一般为 2 至 3 个月。"
        ],
        callout: "专业建议：外籍买家在签署购房意向书 (OTP) 并支付定金时，务必让中介与律师在合同中注明“本交易须在成功获取州政府同意书 (State Consent) 及银行贷款批准后方可生效，若申请不获批准定金须全额退还”的法律保护条款。"
      }
    ]
  },
  {
    id: "g4",
    slug: "malaysia-first-home-buyer-complete-guide-cn",
    title: "在马来西亚购买第一套房产的完整步骤与指南 (2026最新首购族精简版)",
    category: "Buying Guide",
    date: "Mar 2026",
    readTime: "8 分钟阅读",
    author: "妮可地产经纪 (Nicole Pua)",
    coverImage: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1200&q=80",
    summary: "专为马来西亚首次购房者（首购族）精心梳理的买房完整流程指南，涵盖预算评估、申请房贷、签署买卖合同(SPA)、律师与印花税费用以及交房拿钥匙的实战要点。",
    highlights: [
      "精算购房准备金：头期款 10% + 预留约 3-5% 的律师费与印花税等交易成本",
      "评估个人 DSR 偿债比率，确保房屋贷款顺利获得 90% 高额度审批",
      "对比新楼盘 (New Launch) 与二手房 (Subsale) 的优势与优惠配套",
      "首购族印花税 (MOT & Loan Agreement) 豁免政策精要拆解",
      "拿钥匙 (Vacant Possession) 验房与 24 个月缺陷保障期 (DLP) 检查清单"
    ],
    sections: [
      {
        heading: "第一步：精准评估购房预算与个人贷款额度",
        image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "买房前最关键的一步是清晰掌握自己的财务状况。在马来西亚买房，除了准备房屋价格 10% 的首付款（头期钱）外，还需预留约 3% - 5% 的相关交易费用（包括律师费、印花税、房屋估价费及房屋保险费）。",
          "银行审批房贷时主要参考 DSR（Debt Service Ratio 偿债率）：DSR = (每月所有债务供款 + 拟申请房屋贷款每月供款) ÷ 每月净收入。建议将 DSR 控制在 60% 至 70% 以内，并提前确保 CCRIS 与 CTOS 信用记录良好。"
        ],
        callout: "提示：对于符合条件的首购族，马来西亚政府或特定银行常推出高达 90% - 100% 的首购族贷款计划（如 SRP 或首购族印花税减免优惠）。"
      },
      {
        heading: "第二步：选择适合的房产类型（新楼盘 vs 二手房）",
        image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "在看房前，先明确自身需求与现金流预算：",
          "• 新楼盘 (Primary / New Launch)：优势在于入场门槛低，许多开发商提供免头期配套、免买卖合同 (SPA) 律师费及免费赠送部分家电；拥有 24 个月的房屋缺陷保障期 (DLP)。缺点是需要等待 2 至 3 年建期。",
          "• 二手房 (Subsale)：优势在于现房即买即住或即可出租，地段成熟，周边配套完善，且能实地考察房屋实际采光与小区物业管理状况。缺点是需要准备较充足的现金支付头期款与律师费。"
        ]
      },
      {
        heading: "第三步：下定金与签署购房意向书 (Offer to Purchase / OTP)",
        paragraphs: [
          "看中心仪的房产后，买方需向房产中介公司的信托账户或开发商下付 2% 至 3% 的意向定金 (Earnest Deposit)，并签署购房意向书 (OTP)。",
          "意向书中会明确标明房屋成交价格、定金数额、申请贷款的期限（通常为 14 至 21 个工作日），以及若贷款不幸不获批准时定金全额退款的相关条款。"
        ]
      },
      {
        heading: "第四步：向银行申请房屋贷款",
        paragraphs: [
          "拿到签署好的 OTP 意向书后，需尽快向 3 至 4 家商业银行（如 Maybank, Public Bank, CIMB, Hong Leong, RHB, UOB 等）提交贷款申请，以便比较利率与贷款条件。",
          "需准备的基础贷款文件包括：身份证副本、最新 3 个月薪水单 (Pay Slip)、最新 3 个月银行账单 (Bank Statement)、最新 EPF 公积金结单，以及 EA 表格/所得税报税单。"
        ]
      },
      {
        heading: "第五步：签署买卖合同 (SPA) 与贷款协议 (Loan Agreement)",
        image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "当银行出具贷款审批信 (Offer Letter) 并由买家确认签署后，代理律师将准备买卖合同 (Sales & Purchase Agreement, SPA)。",
          "买方需在签署 SPA 时付清剩余的头期差额（如总计 10%），随后在律师协助下签署银行贷款协议 (Loan Agreement)。"
        ]
      },
      {
        heading: "第六步：支付交易税费与转让印花税 (MOT)",
        paragraphs: [
          "买房交易涉及的法定税费主要包括：律师服务费（按律政法定阶梯费率计算）、转让备忘录印花税 (MOT Stamp Duty) 及贷款协议印花税 (Loan Stamp Duty 0.5%)。",
          "首次购买 RM 500,000 以下住宅房产的马来西亚公民，可享有 100% MOT 及贷款协议印花税全额豁免优惠，大幅降低首购族的前期资金负担。"
        ]
      },
      {
        heading: "第七步：拿钥匙交房 (Vacant Possession) 与验房",
        paragraphs: [
          "当银行完成清算分期拨付款项给卖家或开发商后，卖家/开发商将正式交付钥匙 (Vacant Possession, VP)。",
          "拿钥匙后切记第一时间进行验房 (Defect Inspection)，仔细检查水管泄露、墙面开裂、开关插座及门窗密封性。若是新楼盘，可在 24 个月 Defects Liability Period 缺陷担保期内要求开发商免费修复。"
        ]
      }
    ]
  },
  {
    id: "g8",
    slug: "malaysia-housing-loan-types-approval-guide-cn",
    title: "马来西亚房屋贷款全指南：4大房贷类型与高额度审批避坑技巧",
    category: "Buying Guide",
    date: "July 2026",
    readTime: "8 分钟阅读",
    author: "妮可地产经纪 (Nicole Pua)",
    coverImage: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1200&q=80",
    summary: "买房申请房贷不知选哪种？本文为您拆解马来西亚三大传统房贷（Term Loan、Semi-Flexi、Full-Flexi）与伊斯兰房贷的利弊，并总结提高银行贷款审批通过率与获得高额度的 5 大核心技巧。",
    highlights: [
      "4 大房贷类型拆解：定期贷款 (Term Loan)、半灵活贷款 (Semi-Flexi)、全灵活贷款 (Full-Flexi) 及伊斯兰房贷",
      "偿债率 (DSR) 精算：控制在 60%-70% 避免贷款被拒，合理利用个人公积金与副收益",
      "信用记录维护：提前 3-6 个月改善 CCRIS 与 CTOS 信用评级，避免延迟还款",
      "必备申请文件与锁定期 (Lock-in Period) 违约金避坑要点"
    ],
    sections: [
      {
        heading: "一、马来西亚 4 大房屋贷款类型拆解",
        image: "https://images.unsplash.com/photo-1556742049-0a67daf40955?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "申请房屋贷款前，了解银行提供的不同贷款产品类型至关重要。马来西亚主流房贷主要分为四大类：",
          "1. 定期贷款 (Term Loan)：传统的固定房贷，每月还款额固定。即使您手头有闲钱多还了款，多还的部分也直接用于扣减本金，无法自由提取领回。优点是利率稳定、规则简单，适合预算固定、追求稳定的买家。",
          "2. 半灵活贷款 (Semi-Flexi Loan)：目前市场最普及的房贷产品。允许借款人将额外资金存入房贷账户扣减利息（按日计算利息）。若日后急需用钱，可向银行申请将多还的部分提取出来，每次提取需支付约 RM 50 手续费。",
          "3. 全灵活贷款 (Full-Flexi Loan)：房贷账户直接与日常往来支票账户 (Current Account) 关联，存入账户的任何资金都会自动抵扣房贷本金利息。借款人可通过网银或 ATM 随时自由存取资金，无需额外申请或手续费。适合现金流充沛、手头常有大额周转资金的投资客（注：通常每月需缴纳 RM 10 左右账户维护费）。",
          "4. 伊斯兰房贷 (Islamic Housing Financing)：基于伊斯兰律法 (Shariah) 架构下的买卖契约（如 Murabahah 或 Tawarruq 概念），银行先购入房产再按约定利润率转售给买家。无利息 (Riba) 概念，还款额上限受封顶利息保障，吸引不少非穆斯林买家选择。"
        ]
      },
      {
        heading: "二、提高房贷审批通过率与获得高额度的 5 大核心技巧",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "向银行递交贷款申请时，银行审批部门会严格考核借款人的还款能力与信用风险：",
          "1. 控制偿债比率 (DSR 60% 以内)：DSR 算式为：(当前所有债务每月供款 + 拟申请房贷每月供款) ÷ 每月净收入。建议将 DSR 控制在 60% 以下，审批通过率最高。",
          "2. 保持健康的 CCRIS 与 CTOS 信用评级：银行会调阅国家银行 CCRIS 信用报告。递交申请前 3 至 6 个月内，务必确保信用卡、汽车贷款及个人贷款无任何延迟还款记录（不要出现数字 '1' 或 '2'）。",
          "3. 准备齐全且规范的收入证明：首购族需准备最新 3 至 6 个月薪水单、银行入账流水、EPF 公积金结单及 EA 报税单。自雇人士需准备 SSM 商业注册、6 个月公司银行流水及近两年 BE 报税单。",
          "4. 注意房贷锁定期 (Lock-in Period)：商业银行房贷通常设有 3 至 5 年的锁定期。若在锁定期内提前全额还清贷款或转贷 (Refinance)，银行将收取相当于总贷款额 2% 至 3% 的罚金。",
          "5. 多家银行同时申请对比：建议同时向 3 至 4 家大银行（如 Maybank, Public Bank, CIMB, Hong Leong, RHB 等）提交申请，以便对比各家给出的配套利率 (Margin of Financing & Interest Rate) 及费用优惠。"
        ],
        callout: "专业建议：递交申请前，可先找专业地产经纪或独立房贷顾问免费帮您精算 DSR 与审核 CCRIS 状态，确保万无一失。"
      }
    ]
  },
  {
    id: "g9",
    slug: "sg-work-apply-malaysia-housing-loan-guide-cn",
    title: "新加坡工作申请马来西亚房贷全攻略：必备资料清单与审批避坑指南",
    category: "Buying Guide",
    date: "August 2026",
    readTime: "6 分钟阅读",
    author: "妮可地产经纪 (Nicole Pua)",
    coverImage: "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?auto=format&fit=crop&w=1200&q=80",
    summary: "人在新加坡工作，想在马来西亚买房贷款？本文为您整理最完整的新加坡雇员与自雇人士申请马国房贷的必备资料清单（包含NOA、CBS、薪水单等），并拆解如何精算DSR偿债率，助您轻松快速获批房贷。",
    highlights: [
      "新加坡工作申请马国房贷核心要点：贷款额度、利率与DSR偿债率精算",
      "新加坡雇员/自雇人士必备材料清单：IC/护照、PR/工作准证、3-6个月薪水单与银行流水",
      "关键信用与税务证明：NOA（所得税评估）、IR8A及新加坡CBS信用报告的提报技巧",
      "避坑建议：如何避免因为资料不齐或DSR超标导致贷款被拒，以及多家银行对比策略"
    ],
    sections: [
      {
        heading: "一、人在新加坡，申请马来西亚房贷容易吗？",
        image: "https://images.unsplash.com/photo-1549490349-8643362247b5?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "许多在新加坡工作或持有新加坡永久居民 (PR) 身份的购房者，希望在柔佛新山 (Johor Bahru) 或吉隆坡置业。只要拥有稳定的新加坡元收入与合规的工作准证，申请马来西亚的房贷其实非常顺畅。",
          "绝大多数马来团队和银行对在新加坡工作的申请者都抱持非常欢迎的态度，可提供的贷款额度 (Margin of Financing) 通常在 70% 至 85% 之间，具体取决于申请者的财务状况与信用评级。由于新加坡元汇率优势，转换后能显著降低您的总债务偿还率 (DSR)，从而让您的贷款更容易获批。"
        ]
      },
      {
        heading: "二、新加坡工作者申请房贷必备资料清单",
        image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "想轻松拿下房贷？资料的准备是决定审批速度和成败的核心。在递交申请前，请提前准备好以下完整文件：",
          "1. 基础身份证明：您的身份证 (IC) 复印件，以及护照的个人资料页清晰复印件。",
          "2. 新加坡工作/居留准证：新加坡永久居民 (PR) 蓝卡 (Blue NRIC)、Employment Pass (EP)、S-Pass 或 Work Permit 🆔 复印件。",
          "3. 稳健的收入证明：最近 3 至 6 个月的新加坡薪水单 (Singapore Pay Slip) 💵，需清晰显示您的雇主名称、基本薪资和所有补贴。",
          "4. 新加坡银行账单：最近 3 至 6 个月的新加坡银行对账单 (Singapore Bank Statement) 📑，必须是您接收工资的那个银行账户，用来核对每一笔薪资的真实入账情况。",
          "5. 税务评估单 (NOA) 与 IR8A：新加坡税局（IRAS）出具的最新所得税评估单 (Notice of Assessment, NOA) 以及雇主提供的年度 IR8A 表格。",
          "6. 个人信用报告：如果您是新加坡 PR，需要提供新加坡信用局出具的 CBS 报告 (Credit Bureau Singapore Report) 📜。银行会通过这份报告核查您在新加坡的信贷习惯与是否存在未清债务。"
        ]
      },
      {
        heading: "三、提高贷款审批率与避坑技巧",
        image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1000&q=80",
        paragraphs: [
          "1. 严格控制偿债率 (DSR)：虽然新币折合令吉后额度较大，但银行计算 DSR 时，会将您在新加坡的固定负债（如租金、车贷、信用卡负债）和拟申请的马国房贷一同计入。DSR 维持在 60% 以下审批率最高。",
          "2. 避免频繁更换工作：银行通常更倾向批准在当前雇主处服务满 6 个月以上的申请人。若刚好处于试用期或刚跳槽，建议转正后再提交申请，或提供前一份工作的完整收入证明。",
          "3. 信用状况保持健康：递交申请前 3 至 6 个月内，确保所有的信用卡账单与贷款都在到期日前全额还清，避免在 CCRIS 或新加坡 CBS 报告中留下逾期还款记录。"
        ],
        callout: "妮可地产贴士：资料齐全 = 审批更快，省时又省心！建议您同步向 3 到 4 家大银行提交申请，不仅能提高获批概率，还能在拿到 Offer 后对比谁的利息更低、是否有锁定期等优惠配套。"
      }
    ]
  }
];

// Always export guides sorted by date descending (newer first)
export const GUIDES_DATA = [...RAW_GUIDES_DATA].sort(
  (a, b) => parseGuideDate(b.date) - parseGuideDate(a.date)
);

export const GUIDE_CATEGORIES = [
  "All Guides",
  "Foreign Buyers",
  "Buying Guide",
  "Township Insights"
];
